import React, { useEffect, useState } from 'react'
import usePrevious from '../../hooks/common/usePrevious'
import isEqual from 'lodash/isEqual'
import { useQuery } from '../hooks/useQuery'

const withAutocomplete = BaseComponent => props => {
  const [formattedSuggestions, setFormattedSuggestions] = useState([])
  const operation = 'studentAppAutocomplete'
  const defaultVariables = {
    prefix: { value: '', required: true },
    field: { value: '', required: true },
  }

  const { data: suggestions, refetch, loading } = useQuery(operation, defaultVariables, {
    lazy: true,
  })

  const prevSuggestions = usePrevious(suggestions)
  useEffect(() => {
    if (!isEqual(prevSuggestions, suggestions)) {
      const formattedSuggs = suggestions ? suggestions.map(sugg => ({ name: sugg })) : []

      setFormattedSuggestions(formattedSuggs)
    }
  })

  const clearSuggestions = () => setFormattedSuggestions([])

  return (
    <BaseComponent
      {...props}
      suggestions={formattedSuggestions}
      getAutocompleteResults={refetch}
      isPerformingSearch={loading}
      clearSuggestions={clearSuggestions}
    />
  )
}

export default withAutocomplete



// WEBPACK FOOTER //
// ./src/utils/graphql/hocs/withAutocomplete.js